import Button from "components/common/Button/Button";
import ButtonWrapper from "components/common/ButtonWrapper";
import NumPad, { MediumCenteredNumPad } from "components/common/NumPad";
import PhoneNumberInput from "components/common/PhoneNumberInput/PhoneNumberInput";
import RightLeftLayout from "components/common/RightLeftLayout/RightLeftLayout";
import Title from "components/common/Title";
import * as React from "react";
import { OnboardingContainerProvider } from "screens/Onboarding/Onboarding.container";
import { ThemeProvider } from "themes";
import theme, { GlobalStyle } from "themes/simple-theme";

interface IProp {
  className?: string;

  history: {
    push: (to: string) => void;
  };
}

interface IState {
  pairingUrl?: string;
  pairingCode: string;
}

class Pairing extends React.Component<IProp, IState> {
  constructor(props: IProp) {
    super(props);
    this.state = {
      pairingUrl: "",
      pairingCode: ""
    };
  }
  public async componentDidMount() {
    const url = new URL(window.location.href);
    const loginChallenge = url.searchParams.get("login_challenge") || "";

    const config = await (await fetch("/config.json")).json();
    const pairingUrl = `${config.auth_pairing_url}?login_challenge=${loginChallenge}`;

    this.setState({ pairingUrl });
  }

  public render() {
    return (
      <OnboardingContainerProvider>
        <ThemeProvider theme={theme}>
          <>
            <GlobalStyle />
            <div className={this.props.className}>
              <RightLeftLayout
                title="Activate Tablet"
                centerLeftContent
                leftPanel={
                  <div>
                    <Title> Enter Pairing Code</Title>
                    <form action={this.state.pairingUrl} method="POST">
                      <PhoneNumberInput
                        name="pairing_code"
                        type="text"
                        id="pairing_code"
                        largeText
                        value={this.state.pairingCode}
                        fullWidth
                      />

                      <ButtonWrapper>
                        <Button primary style={{ width: "30vh" }}>
                          Activate
                        </Button>
                      </ButtonWrapper>
                    </form>
                  </div>
                }
                rightPanel={
                  <MediumCenteredNumPad>
                    <NumPad onTap={this.onTap} />
                  </MediumCenteredNumPad>
                }
              />
            </div>
          </>
        </ThemeProvider>
      </OnboardingContainerProvider>
    );
  }

  private onTap = (value: string) => {
    this.setState((state: IState) => {
      const pairingCode =
        value === "back"
          ? state.pairingCode.slice(0, state.pairingCode.length - 1)
          : `${state.pairingCode}${value}`;

      return {
        pairingCode
      };
    });
  };
}

export default Pairing;



// WEBPACK FOOTER //
// ./src/screens/Authorization/pairing.tsx